import React, {Component} from 'react'
import {connect} from 'react-redux'
import {createResource, deleteResource, getResource, updateResource} from '../../../data/actions/resource'
import {
    checkPerm,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getProp,
    mergeDeep,
    returnOffsetAndPagination,
    saveTableColumns
} from '../../../common/util/util-helpers'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {Field, FieldsManager} from '../../../data/services/fields'
import {CREATE_PERM, DEFAULT_CRUD_STATE, DELETE_PERM, MAJOR_ACCOUNT_TYPE_EXPENSE} from '../../../util/util-constants'
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";
import NoRecordsTable from "../../../common/components/no-records-found/no-records-table";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import ResourceTable from "../../../common/components/resource-table";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import {fillFieldsFromData} from "../../../common/util/util-fields";
import Button from '../../../common/components/button'
import {DEFAULT_QUERY_LIMIT} from '../../../common/util/util-consts'

export function getFields(item = {}) {
    const fieldTemplates = {
        Date: new Field('Date', '', ['empty'], false, 'date', {addContainerClass: "col-span-full"}),
        ProductServiceID: new Field('ProductServiceID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-full"}),
        QtyChange: new Field('QtyChange', '', ['required', 'integer_new', 'non-zero'], false, 'text', {addContainerClass: "col-span-full"}),
        Reason: new Field('Reason', '', ['empty'], false, 'text', {addContainerClass: "col-span-full"}),
        AccountID: new Field('AccountID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-full"}),
    }

    return fillFieldsFromData(fieldTemplates, item)
}

export function getQueryFields() {
    return {
        query: new Field('query', '', [''], false, 'search', {}, {}),
        sortBy: new Field('sortBy', 'Date', [''], false, 'text', {}, {}),
        offset: new Field('offset', "0", [''], false, 'text', {}, {}),
        limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: 'top'})
    }
}

class InventoryAdjustmentTab extends Component {
    constructor(props) {
        super(props)
        this.pagePath = this.props.location.pathname.substring(1) + '_inv_adjustment'
        this.state = {
            // Default state
            ...DEFAULT_CRUD_STATE,
            sortBy: 'Date',
            sort: "DESC",

            // Fields
            fields: getFields(),
            tableOptions: getDefaultTableOptions(getFields(), {}, this.pagePath, this.props.translate),

            // Filter, and header fields
            queryFilterFields: getQueryFields(),

            // Dialogs
            isFormDialogVisible: false,
            confirmDialog: false
        }

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath))
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.breakpoint !== this.props.breakpoint && this.props.breakpoint.index <= 1 && this.state.queryFilterFields.limit.value !== 10) {
            this.handleFilterInputChange('limit', 10)
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: this.getQuery()
        }))
    }

    archiveResource = (item) => {
        this.setState({text: this.props.translate('message.confirm_delete_generic') + ` ${item.Reason}?`}, () => {
            this.handleToggleConfirmDialog(() => {
                this.setState({
                    ...returnOffsetAndPagination(getProp(this.props.resource.data, 'list', []), this.getQuery(), this.state.paginationPage),
                    confirmDialog: false
                }, () => {
                    this.props.dispatch(deleteResource({
                        user: LocalStorage.get('user'),
                        query: Object.assign({
                            InventoryAdjustmentID: item.InventoryAdjustmentID
                        }, this.getQuery()),
                        errorMessage: true,
                        successMessage: this.props.translate(`message.delete_generic`, [item.Reason]),
                        resource: this.getResource(),
                        piggyResource: this.getResource()
                    }))
                })
            }, item)
        })
    }

    /** UI Events
     ================================================================= */
    handleToggleConfirmDialog = (submit, item) => {
        this.setState({
            confirmModal: submit,
            confirmDialog: true
        })
    }

    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    toggleResourceForm = (item = {}) => {
        this.setState({
            isFormDialogVisible: !this.state.isFormDialogVisible,
            selectedItem: item
        })
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleClearFiltersClick = (excludeAdditional = []) => {
        const queryFilterFields = Object.assign({}, this.state.queryFilterFields)
        const defaultExcludedFields = ['limit']
        const excludedFields = defaultExcludedFields.concat(excludeAdditional)

        Object.values(queryFilterFields).filter(it => !excludedFields.includes(it.name)).forEach(it => {
            FieldsManager.updateField(queryFilterFields, it.name, '')
        })

        this.setState({
            queryFilterFields: queryFilterFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleSetTableColumnOptions = (columns) => {
        let tableOptions = Object.assign({}, this.state.tableOptions)

        tableOptions.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        this.setState({
            tableOptions,
            columnsModalOpen: false
        }, () => saveTableColumns(this.pagePath, tableOptions))
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(getFields(), {}, this.props.translate)
    }

    handleToggleColumnSettingsDialog = () => {
        this.setState({
            columnsModalOpen: !this.state.columnsModalOpen
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }
    /** Helpers
     ================================================================= */
    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['sortBy', 'sort', 'limit', 'query', 'offset', 'paginationPage', 'showArchived'])
    }

    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,

            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
        }
    }

    getResource = () => {
        return Resources.InventoryAdjustment
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource, dispatch} = this.props
        const data = getProp(resource.data, 'list', [])
        const count = getProp(resource.data, 'count', 0)
        const metadata = {
            ProductServiceID: {
                api: 'api/' + Resources.ProductsServices,
                query: {
                    offset: 0,
                    limit: 20,
                    ProductServiceTypeID: 1
                },
                searchMap: (item) => ({
                    label: item.ProductService,
                    value: item.ProductServiceID,
                    metadata: item
                })
            },
            AccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_EXPENSE
                },
                searchMap: (item) => ({
                    value: item.AccountID,
                    label: item.AccountNumber + ' ' + item.AccountName
                })
            },
        }
        return (
            <React.Fragment>
                <div className="flex mb-2">
                    <ActiveFilters
                        filterFields={this.state.queryFilterFields}
                        onLabelClick={this.handleFilterInputChange}
                        onClearFiltersClick={this.handleClearFiltersClick}
                        translate={translate}
                    />

                    <div className="flex ml-auto">
                        <div className={'flex mr-4'}>
                            <TableSettingsPopOver
                                options={this.state.tableOptions}
                                setOptions={this.setOptions}
                                toggleColumnSettingsDialog={this.handleToggleColumnSettingsDialog}
                                translate={translate}
                            />
                        </div>

                        <Button
                            hasPerm={checkPerm(this.getResource(), CREATE_PERM)}
                            className={`btn btn-primary`}
                            onClick={this.toggleResourceForm}
                        >
                            {translate('btn.create_new')}
                        </Button>
                    </div>
                </div>

                <TableCard addClass={'relative'}>
                    <TableFilters
                        hideLimit
                        filterFields={this.state.queryFilterFields}
                        handleInputChange={this.handleFilterInputChange}
                        translate={translate}
                        onRefreshTable={this.fetchData}
                        isLoading={resource.isLoading}
                    />
                    <ResourceTable
                        data={data}
                        fields={getFields()}
                        verticalTableIsVisible={this.props.breakpoint.index <= 1}

                        translate={translate}
                        isLoading={resource.isLoading}

                        options={this.state.tableOptions}

                        limit={this.state.queryFilterFields.limit.value}

                        sort={this.state.sort}
                        sortBy={this.state.sortBy}
                        onSortChange={this.handleUpdateSort}
                        onDelete={checkPerm(this.getResource(), DELETE_PERM) ? this.archiveResource : null}
                    />

                    {/*Table footer*/}
                    <TableCardFooter
                        show={!(!data.length && !resource.isLoading)}
                    >
                        <Pagination
                            count={count}
                            isLoading={resource.isLoading}
                            hideRowsPerPage={this.props.breakpoint.index <= 1}
                            handleQueryChange={
                                (name, value, currentPage) => name === 'offset'
                                    ? this.handleUpdateOffset(value, currentPage)
                                    : this.handleFilterInputChange(name, value)
                            }
                            pageOffset={this.state.offset}
                            queryFields={this.state.queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>

                    <NoRecordsTable
                        show={(data.length === 0) && !resource.isLoading}
                        canCreate={checkPerm(this.getResource(), CREATE_PERM)}
                        title={'No matching records found'}
                        text={'Create new inventory adjustment'}
                        btnLabel="Create inventory adjustment"
                        onBtnClick={() => {
                            this.toggleResourceForm({Reason: this.state.queryFilterFields.query.value})
                        }}
                        onClearFilterClick={this.handleClearFiltersClick}
                        clearFilterBtnLabel={translate('text.clear_all_filters')}
                        clearFilterText={translate('text.try_without_filters')}
                        filters={this.state.queryFilterFields}
                    />
                </TableCard>

                <ModalSaveResource
                    title={this.props.translate(`text.${this.state.selectedItem?.InventoryAdjustmentID ? 'Edit' : 'CreateNew'}InventoryAdjustment`)}
                    show={this.state.isFormDialogVisible}
                    widthClass="max-w-md"
                    gridColsClass="grid-cols-3"
                    translate={translate}
                    fields={getFields(this.state.selectedItem)}
                    onClose={() => this.toggleResourceForm()}
                    metadata={metadata}
                    onSubmit={(params) => {
                        if (params) {
                            if (this.state.selectedItem.InventoryAdjustmentID) {
                                dispatch(updateResource({
                                    user: LocalStorage.get('user'),
                                    params: Object.assign(params, {
                                        InventoryAdjustmentID: this.state.selectedItem.InventoryAdjustmentID
                                    }),
                                    errorMessage: true, successMessage: `Adjustment has been updated.`,
                                    resource: this.getResource(),
                                    piggyResource: this.getResource()
                                }))
                            } else {
                                dispatch(createResource({
                                    user: LocalStorage.get('user'),
                                    params: Object.assign(params, {
                                        AdjustmentType: 1,
                                        Items: [
                                            {
                                                "ProductServiceID": params.ProductServiceID,
                                                "QtyChange": params.QtyChange,
                                                "ValueChange": 0,
                                                "Reason": params.Reason
                                            }
                                        ]
                                    }),
                                    errorMessage: true,
                                    successMessage: `Adjustment has been created.`,
                                    resource: this.getResource(),
                                    piggyResource: this.getResource()
                                }))
                            }

                            this.toggleResourceForm()
                        }
                    }}
                />

                <ModalConfirm
                    title={'Confirm delete'}
                    show={!!this.state.confirmDialog}
                    text={this.state.text}
                    onClose={() => this.setState({confirmDialog: false})}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={this.state.confirmModal}
                />

                <TableOptionsDialog
                    show={this.state.columnsModalOpen}
                    pagePath={this.pagePath}
                    columns={this.state.tableOptions.columns}
                    setTableColumnOptions={this.handleSetTableColumnOptions}
                    getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                    onClose={this.handleToggleColumnSettingsDialog}
                    translate={translate}
                />
            </React.Fragment>
        )
    }
}

export default connect(state => state)(InventoryAdjustmentTab)
